import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  writeBatch,
} from "firebase/firestore";
import { auth, dbAccounts } from "../../../backend/firebaseConfig";

const BULK_UPLOAD_COLLECTION = "Commission Split Bulk Uploads";
const rowsCollection = (uploadId) =>
  collection(dbAccounts, BULK_UPLOAD_COLLECTION, uploadId, "Rows");

const mapDocument = (snapshot) => ({ id: snapshot.id, ...snapshot.data() });

export const createCommissionSplitBulkUpload = async (preview, userEmail) => {
  const authenticatedEmail = auth.currentUser?.email ||
    auth.currentUser?.providerData?.find((provider) => provider.email)?.email;
  const createdBy = String(authenticatedEmail || userEmail || "").trim().toLowerCase();
  if (!createdBy) {
    throw new Error("Unable to identify the signed-in uploader. Please sign in again.");
  }
  const uploadReference = doc(collection(dbAccounts, BULK_UPLOAD_COLLECTION));
  const batch = writeBatch(dbAccounts);
  batch.set(uploadReference, {
    fileName: preview.fileName,
    sheetName: preview.sheetName,
    referenceType: preview.referenceType || "iob",
    status: preview.validCount ? "queued" : "completed",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    ...(preview.validCount ? {} : { completedAt: serverTimestamp() }),
    createdBy,
    summary: {
      totalRows: preview.totalRows,
      processed: preview.invalidCount,
      successful: 0,
      completed: 0,
      failed: 0,
      skippedInvalid: preview.invalidCount,
    },
  });
  preview.rows.forEach((row) => {
    const rowReference = doc(rowsCollection(uploadReference.id));
    batch.set(rowReference, {
      rowNumber: row.rowNumber,
      iobNumber: row.iobNumber || null,
      policyNumber: row.policyNumber || null,
      referenceType: row.referenceType || "iob",
      status: row.status === "ready" ? "queued" : "invalid",
      reason: row.reason || null,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  });
  await batch.commit();
  return uploadReference.id;
};

export const subscribeCommissionSplitBulkUploads = (onData, onError) =>
  onSnapshot(
    query(
      collection(dbAccounts, BULK_UPLOAD_COLLECTION),
      orderBy("createdAt", "desc"),
      limit(25),
    ),
    (snapshot) => onData(snapshot.docs.map(mapDocument)),
    onError,
  );

export const subscribeCommissionSplitBulkRows = (uploadId, onData, onError) => {
  if (!uploadId) {
    onData([]);
    return () => {};
  }
  return onSnapshot(
    query(rowsCollection(uploadId), orderBy("rowNumber", "asc")),
    (snapshot) => onData(snapshot.docs.map(mapDocument)),
    onError,
  );
};
